import AbstractAction from 'utils/AbstractAction'

class Action extends AbstractAction {
  _namespace = 'Profile'
}

const setSellProfileData = new Action('setSellProfileData', {
  init: (sellProfileData, callback) => ({ sellProfileData, callback }),
  success: (data) => data,
  failure: (error) => ({ error }),
})

const setPendingNotificationModalType = new Action('setPendingNotificationModalType', {
  init: (pendingNotificationModalType, callback) => ({ pendingNotificationModalType, callback }),
  success: (data) => data,
  failure: (error) => ({ error }),
})

const updateAccountField = new Action('updateAccountField', {
  init: (key, value, callback) => ({ key, value, callback }),
  success: (data) => data,
})

const fetchProfileInfo = new Action('fetchProfileInfo', {
  init: (callback) => ({ callback }),
  success: (data) => data,
})

const fetchReferralData = new Action('fetchReferralData', {
  init: (callback) => ({ callback }),
  success: (data) => data,
})

const setReklaimRewardsTag = new Action('setReklaimRewardsTag', {
  init: (callback) => ({ callback }),
  success: (data) => data,
  failure: (error) => ({ error }),
})

const setIsProfileRewardsMember = new Action('setIsProfileRewardsMember', {
  init: (isProfileRewardsMember, callback) => ({
    isProfileRewardsMember,
    callback,
  }),
  success: (data) => data,
})

const addPhoneNumberSendSmsCode = new Action('addPhoneNumberSendSmsCode', {
  init: (phoneNumber, callback) => ({ phoneNumber, callback }),
  success: (data) => data,
})

const addPhoneNumberVerifySmsCode = new Action('addPhoneNumberVerifySmsCode', {
  init: (phoneNumber, code, callback) => ({ phoneNumber, code, callback }),
  success: (data) => data,
})

const deleteAccount = new Action('deleteAccount', {
  init: (callback) => ({ callback }),
  success: (data) => data,
})

const removeEmailAddress = new Action('removeEmailAddress', {
  init: (emailAddress, callback) => ({ emailAddress, callback }),
})

const removePhoneNumber = new Action('removePhoneNumber', {
  init: (phoneNumber, callback) => ({ phoneNumber, callback }),
})

const setIsFinancialDividendMember = new Action('setIsFinancialDividendMember', {
  init: (isFinancialDividendMember, callback) => ({ isFinancialDividendMember, callback }),
  success: (data) => data,
})

const setIsBrowsingRewardsMember = new Action('setIsBrowsingRewardsMember', {
  init: (isBrowserDividendMember, callback) => ({ isBrowserDividendMember, callback }),
  success: (data) => data,
})

const setIsDeviceRewardsMember = new Action('setIsDeviceRewardsMember', {
  init: (isDeviceRewardsMember, callback) => ({ isDeviceRewardsMember, callback }),
  success: (data) => data,
})

const setIsUnveilPrompted = new Action('setIsUnveilPrompted', {
  init: (isUnveilPrompted, callback) => ({ isUnveilPrompted, callback }),
  success: (data) => data,
})

const setEnableSmsNotifications = new Action('setEnableSmsNotifications', {
  init: (isEnabled, callback) => ({ isEnabled, callback }),
  success: (data) => data,
})

const setEnableEmailNotifications = new Action('setEnableEmailNotifications', {
  init: (isEnabled, callback) => ({ isEnabled, callback }),
  success: (data) => data,
})

const setHasPendingUnveilNotification = new Action('setHasPendingUnveilNotification', {
  init: (hasPendingUnveilNotification, callback) => ({ hasPendingUnveilNotification, callback }),
  success: (data) => data,
  failure: (error) => ({ error }),
})

const addEmailAddressSendVerificationEmail = new Action('addEmailAddressSendVerificationEmail', {
  init: (emailAddress, source, callback) => ({ emailAddress, source, callback }),
  success: (data) => data,
})

const setDeviceData = new Action('setDeviceData', {
  init: (ipAddress, userAgent, browserLanguage) => ({ ipAddress, userAgent, browserLanguage }),
  success: (data) => data,
  failure: (error) => ({ error }),
})

const clearSmsErrorMessage = new Action('clearSmsErrorMessage', {
  success: (data) => data,
})

const addEmailAddressVerifyToken = new Action('addEmailAddressVerifyToken', {
  init: (token, callback) => ({
    token,
    callback,
  }),
})

const upsertIpAddress = new Action('upsertIpAddress', {
  init: (ipAddress, country, countryRegion, callback) => ({ ipAddress, country, countryRegion, callback }),
  failure: (error) => ({ error }),
})

const fetchBrowsingRewardsStatistics = new Action('fetchBrowsingRewardsStatistics', {
  init: (callback) => ({ callback }),
  success: (records) => ({ records }),
})

const setPrimaryEmailAddress = new Action('setPrimaryEmailAddress', {
  init: (emailAddress, callback) => ({ emailAddress, callback }),
})

const setPrimaryPhoneNumber = new Action('setPrimaryPhoneNumber', {
  init: (phoneNumber, callback) => ({ phoneNumber, callback }),
})

const setUserHandle = new Action('setUserHandle', {
  init: (userHandle, callback) => ({ userHandle, callback }),
})

const uploadProfilePicture = new Action('uploadProfilePicture', {
  init: (profilePictureCanvas, fileName, callback) => ({ profilePictureCanvas, fileName, callback }),
})

const setIsUnveilOnboarded = new Action('setIsUnveilOnboarded', {
  init: (callback) => ({ callback }),
  success: (data) => data,
})

export default {
  setSellProfileData,
  setPendingNotificationModalType,
  updateAccountField,
  fetchProfileInfo,
  fetchReferralData,
  setReklaimRewardsTag,
  addPhoneNumberSendSmsCode,
  addPhoneNumberVerifySmsCode,
  deleteAccount,
  removeEmailAddress,
  removePhoneNumber,
  setIsFinancialDividendMember,
  setIsBrowsingRewardsMember,
  setIsDeviceRewardsMember,
  setEnableSmsNotifications,
  setEnableEmailNotifications,
  setHasPendingUnveilNotification,
  setIsProfileRewardsMember,
  addEmailAddressSendVerificationEmail,
  setDeviceData,
  setIsUnveilPrompted,
  clearSmsErrorMessage,
  addEmailAddressVerifyToken,
  upsertIpAddress,
  fetchBrowsingRewardsStatistics,
  setPrimaryEmailAddress,
  setPrimaryPhoneNumber,
  setUserHandle,
  uploadProfilePicture,
  setIsUnveilOnboarded,
}
